import {useState} from 'react';

export interface DraftState<TData> {
  data: TData;
  updateDraftData: (update: Partial<TData>) => void;
  isEditing: boolean;
  startEditing: () => void;
  stopEditing: () => void;
}

export default function useDraftState<TData>(initialData: TData): DraftState<TData> {
  const [draftData, setDraftData] = useState(initialData);
  const [isEditing, setIsEditing] = useState(false);
  return {
    data: isEditing ? draftData : initialData,
    updateDraftData: (update: Partial<TData>) => {
      setDraftData((current) => ({...current, ...update}));
    },
    isEditing,
    startEditing: () => {
      // Whenever we start editing, our draft state needs to be re-set to the current value of initialData
      if (!isEditing) {
        setDraftData(initialData);
        setIsEditing(true);
      }
    },
    stopEditing: () => {
      setIsEditing(false);
    },
  };
}
